import * as Sentry from '@sentry/browser';

export const logException = (error) => {
    Sentry.captureException(error);
};
